export default "/images/paychex-logo.png?76f445488e52a448579bfaba95841634";